import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const ViewRequestDetailsPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.ViewRequestDetails />
    </div>
  );
};

export default ViewRequestDetailsPage;
